import { render } from "./FormUploadMultiple.vue?vue&type=template&id=164fb8f6&scoped=true"
import script from "./FormUploadMultiple.vue?vue&type=script&lang=js"
export * from "./FormUploadMultiple.vue?vue&type=script&lang=js"

import "./FormUploadMultiple.vue?vue&type=style&index=0&id=164fb8f6&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164fb8f6"]])

export default __exports__